// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer__jBSi2","footerContent":"footerContent__2AhPX","column":"column__3hyGM","link":"link__fClZu","firstLink":"firstLink__76UBV","title":"title__3b7h5"};